import { gql } from "@apollo/client";

const CUSTOM_DONATION_FIELDS = `
  _id
  entityId
  entityType
  entityName
  title
  description
  status
  isCustomLink
  donationType
  customPaymentLink
  isVerified
  verifiedBy
  verifiedAt
  rejectionReason
  createdBy
  createdAt
  updatedAt
  publishedAt
`;

/** Super-admin custom-link review list. status: pending | approved | rejected | all */
export const GET_CUSTOM_DONATIONS_FOR_REVIEW = gql`
  query GetCustomDonationsForReview($status: String, $page: Int, $limit: Int) {
    pendingCustomDonations(status: $status, page: $page, limit: $limit) {
      ${CUSTOM_DONATION_FIELDS}
    }
  }
`;
